import type { ElectedRole, MemberStatus } from "../../api/members";
import { AvatarBadge } from "../AvatarBadge";
import { ElectedRoleBadges } from "./ElectedRoleBadges";

interface MemberIdentityHeaderProps {
  fullName: string;
  preferredName?: string | null;
  username?: string | null;
  status: MemberStatus;
  electedRoles?: ElectedRole[];
}

function statusLabel(status: MemberStatus): string {
  if (status === "suspenso_disciplinar") return "Suspenso disciplinar";
  if (status === "desligado") return "Desligado";
  return "Ativo";
}

/**
 * Cabeçalho de identidade da ficha do associado — ponto de entrada visual da tela (Fase 3).
 * Substitui o título de texto puro anterior. Situação e cargos eletivos aparecem aqui para
 * leitura rápida; o registro completo (categoria, efetivação) continua em "Vínculo institucional".
 */
export function MemberIdentityHeader({ fullName, preferredName, username, status, electedRoles }: MemberIdentityHeaderProps) {
  const displayName = preferredName?.trim() || fullName;

  return (
    <div className="member-identity-header">
      <AvatarBadge name={displayName} username={username ?? displayName} size="lg" />
      <div className="member-identity-header__text">
        <h1>{displayName}</h1>
        {preferredName && <p className="member-identity-header__legal-name">{fullName}</p>}
        <div className="member-identity-header__meta">
          <span className={`member-status member-status--${status}`}>{statusLabel(status)}</span>
          <ElectedRoleBadges roles={electedRoles} variant="detailed" />
        </div>
      </div>
    </div>
  );
}
